import styled from 'styled-components/macro';

export const Wrapper = styled.div`
    display: inline-block;
    position: absolute;
    top: 0;
    left: 5px;
    transform: translateY(-25%);
    z-index: 5;
    background-color: #ffff;
`;
